import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { SectionPaper } from "@/components/Paper";
import { StoredCommercialPictureFeedGrid } from "./StoredCommercialPictureFeedGrid";
import { StoredListLoadError } from "./StoredListLoadError";
import type { StoredCommercialPicture } from "../types";

interface Props {
  /** 検索結果（登記明細）。undefined は初回の読み込み前 */
  results: StoredCommercialPicture[] | undefined;
  /** 検索中かどうか */
  loading: boolean;
  /** 一覧の読み込みに失敗したか。結果が無いときだけ失敗を表示する */
  loadFailed: boolean;
  /** 共有ONの会社か */
  isSharable: boolean;
}

/**
 * 「登記から探す」タブの結果ビュー。
 * 上部の共通検索で取得した登記明細（子）をそのまま一覧表示する。各行から所属する取得依頼（親）へ戻れる。
 */
export const StoredCommercialPictureSearchPanel: React.FC<Props> = (props) => {
  const { results, loading, loadFailed, isSharable } = props;
  const theme = useTheme();
  // SP（md未満）はカード表示。外側の白カードは付けず、カードだけをページ背景に並べる
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const content =
    results === undefined && loadFailed && !loading ? (
      <StoredListLoadError />
    ) : (
      <StoredCommercialPictureFeedGrid
        rows={results ?? []}
        loading={loading || results === undefined}
        isSharable={isSharable}
      />
    );

  if (isMobile) {
    return (
      <Box>
        {content}
        <Box sx={{ mb: 6 }} />
      </Box>
    );
  }

  return (
    <SectionPaper>
      {content}
      <Box sx={{ mb: 6 }} />
    </SectionPaper>
  );
};
